import Vue from 'vue'

class VideonShadowTemplate {
  constructor(target_object, target_guid, template_name, template_attributes = false) {
    this.target_object = target_object
    this.target_guid = target_guid
    
    this.template_guid = false
    this.template_name = template_name
    
    this.ready = false
    
    this.loading = false
    
    this.error = false
    this.errorText = ''
    
    this.templates = (template_attributes) ? template_attributes.templates : []
    this.state = []
    
    var template = this.templates.find((template) => template.template_name == this.template_name)
    if (template && template.state) {
      this.state = template.state
    }
    
    if (!template_attributes) {
      this.fetchShadowTemplate()
    }
  }
  
  refresh() {
    this.fetchShadowTemplate()
  }
  
  fetchShadowTemplate() {
    if (!this.target_object || !this.target_guid || !this.template_name) {
      return
    }
    
    this.loading = true
    
    var requestURL = false
    if (this.target_object == 'org') {
      requestURL = '/orgs/' + this.target_guid + '/shadow_templates?template_names=' + this.template_name
    } else if (this.target_object == 'fleet') {
      requestURL = '/fleets/' + this.target_guid + '/shadow_templates?template_names=' + this.template_name
    }
    
    Vue.axios.get(requestURL)
    .then((response) => {
      console.log('VideonShadowTemplate (' + this.target_object + ', ' + this.target_guid + ', ' + this.template_name + ') fetchShadowTemplate response', response.data)
      
      this.templates = (response.data.templates) ? response.data.templates : []
      
      var template = this.templates.find((template) => template.template_name == this.template_name)
      if (template && template.state) {
        this.template_guid = template.template_guid
        this.state = template.state
      }
      
      this.loading = false
      
      this.ready = true
    }).catch((error) => {
      this.error = true
      this.errorText = Vue.helpers.parseError(error)
      this.loading = false
    })
  }
  
  saveTemplate(state) {
    if (!state || !this.target_object || !this.target_guid || !this.template_name) {
      return
    }
    
    var templates = { 'templates': [
      {
        'template_guid': this.template_guid,
        'template_name': this.template_name,
        'state': state
      }
    ]}
    
    this.loading = true
    
    var requestURL = false
    if (this.target_object == 'org') {
      requestURL = '/orgs/' + this.target_guid + '/shadow_templates'
    } else if (this.target_object == 'fleet') {
      requestURL = '/fleets/' + this.target_guid + '/shadow_templates'
    }
    
    Vue.axios.post(requestURL, templates)
    .then((response) => {
      console.log('VideonShadowTemplate (' + this.target_object + ', ' + this.target_guid + ', ' + this.template_name + ') saveTemplate response', response.data)
      
      this.fetchShadowTemplate()
      
    }).catch((error) => {
      this.error = true
      this.errorText = Vue.helpers.parseError(error)
      this.loading = false
    })
  }
}

export default new class VideonShadowTemplates {
  constructor() {
    this.templates = []
  }
  
  getTemplate(target_object, target_guid, template_name, template_attributes = false) {
    if (!target_object || !target_guid || !template_name) {
      console.log('VideonShadowTemplates getTemplate missing target_object or target_guid or template_name', target_object, target_guid, template_name, template_attributes)
      return false
    }
    
    var template = this.templates.find(x => x.target_object === target_object && x.target_guid === target_guid && x.template_name === template_name)
    if (template) {
      return template
    }
    
    template = Vue.observable(new VideonShadowTemplate(target_object, target_guid, template_name, template_attributes))
    this.templates.push(template)
    
    return template
  }
}